import React from 'react';
import { DroneLabelScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/droneLabel/DroneLabelScore';
import { droneLabelScoreToColorCode } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/droneLabel/droneLabelScoreToColorCode';
import { conditionScoreToScore } from '../../../../../common/src/domain/customInspectionTypes/inspectionLabel/droneLabel/droneLabelSettings';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const DroneLabelScoreLabel = React.memo(function DroneLabelScoreLabel(props: { conditionScore: number | undefined | null | string }) {
    if (props.conditionScore === null || props.conditionScore === undefined) {
        return null;
    }
    const droneLabelScore = conditionScoreToScore(props.conditionScore) as DroneLabelScore;
    const colorCode = droneLabelScoreToColorCode(droneLabelScore);

    return (
        <span className="label p5 fs11" style={{ backgroundColor: colorCode }}>
            {droneLabelScore}
        </span>
    );
});
